import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-cards) .block-testimonials .swiper'
);

if (sliders.length > 0) {
	const sliderIndexMap = new Map();
	sliders.forEach((slider, index) => {
		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);
		sliderIndexMap.set(slider, index);
	});

	const initSwiper = (slider) => {
		const index = sliderIndexMap.get(slider);
		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-testimonials__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-testimonials__swiper--${index} .swiper-button-next`,
			},
		};

		new Swiper(slider, settings);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initSwiper(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	sliders.forEach((slider) => observer.observe(slider));
}
